// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1a82C","header":"ReportDetails_header__3paBk","title":"ReportDetails_title__2zRBc","left":"ReportDetails_left__1iIpo"};